import { records } from '~api';
import { getField, updateField } from 'vuex-map-fields';

const SET_LIST = 'SET_LIST';
const TOGGLE_IS_SHORT = 'SET_IS_SHORT';

const state = {
    list: [],
    filters: {
        createdAt: null,
        type: null
    },
    isShort: false
};

const actions = {
    /**
     * Toggle is short
     * @param {function} commit
     */
    async toggleIsShort({ commit }) {
        await commit(TOGGLE_IS_SHORT);
    },
    /**
     * Get records list
     * @param {function} commit
     */
    async getList({ commit, state, dispatch }) {
        if (state.isShort) return dispatch('getShortList');

        const resp = await records.getRecords(state.filters);

        if (resp.ok) {
            const list = resp.data.filter(
                item =>
                    !item.session ||
                    (item.session?.id !==
                        process.env.VUE_APP_JOURNAL_SESSION_ID &&
                        item.session?.id !==
                            process.env.VUE_APP_MINDFUL_MONENTS_SESSION_ID)
            );
            commit(SET_LIST, list);
        }
    },

    /**
     * Get records short list
     * @param {function} commit
     */
    async getShortList({ commit }) {
        const resp = await records.getShortRecords();

        if (resp.ok) {
            const list = resp.data.filter(
                item =>
                    !item.session ||
                    (item.session?.id !==
                        process.env.VUE_APP_JOURNAL_SESSION_ID &&
                        item.session?.id !==
                            process.env.VUE_APP_MINDFUL_MONENTS_SESSION_ID)
            );
            commit(SET_LIST, list.slice(0, 3));
        }
    }
};

const mutations = {
    // Add the `updateField` mutation to the
    // `mutations` of your Vuex store instance.
    updateField,
    [SET_LIST](state, data) {
        state.list = data;
    },
    [TOGGLE_IS_SHORT](state) {
        state.isShort = !state.isShort;
    }
};

const getters = {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
    list: state => state.list
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
